import { render, staticRenderFns } from "./ErrorValidation.vue?vue&type=template&id=2a67c048&"
import script from "./ErrorValidation.vue?vue&type=script&lang=js&"
export * from "./ErrorValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports